/**
 * First-paint signal for the native boot handoff. The splash must not lift
 * until the webview has actually painted the boot canvas, or the lift exposes
 * the document background for a frame. MobileBootScreen resolves this after
 * two animation frames (the second frame guarantees the first was committed);
 * consumers race it against a timeout so a path that never mounts the boot
 * screen cannot hold the splash forever.
 */

let resolveBootPainted: (() => void) | undefined;

export const bootPainted = new Promise<void>((resolve) => {
  resolveBootPainted = resolve;
});

export function markBootPainted(): void {
  resolveBootPainted?.();
  resolveBootPainted = undefined;
}

/** The boot-paint wait never exceeds this; a stuck paint must not hold the splash. */
export const BOOT_PAINT_TIMEOUT_MS = 2000;

export async function bootPaintedOrTimeout(): Promise<void> {
  await Promise.race([
    bootPainted,
    new Promise<void>((resolve) => {
      setTimeout(resolve, BOOT_PAINT_TIMEOUT_MS);
    }),
  ]);
}
